import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Global from '../../../../store/global-selectors';
import messages from '../messages';
import { FormattedWeight } from '../../../../components/formatted-weight';

const WeightColumn = ({ id: presetGroupId }) => {
  const unit = useSelector((state) =>
    Global.selectEntitiesPresetGroupPropertyById(state, {
      profileId: presetGroupId,
      property: 'weightUnitOfMeasureId',
    }),
  );
  const value =
    useSelector((state) =>
      Global.selectEntitiesPresetGroupPropertyById(state, {
        profileId: presetGroupId,
        property: 'weight',
      }),
    ) || 0;
  const weightObject = { unit, value };

  return <FormattedWeight weight={weightObject} />;
};

WeightColumn.propTypes = {
  id: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: messages.weightColumn,
  name: <FormattedMessage {...messages.weightColumn} />,
  id: 'weight',
  isSortable: false,
  render: WeightColumn,
};
